// src/pages/About.jsx
import { Link } from 'react-router-dom';

const AwardIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="#2e7d32" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-10 h-10">
    <circle cx="12" cy="8" r="6"/><path d="M15.477 12.89L17 22l-5-3-5 3 1.523-9.11"/>
  </svg>
);
const LeafIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="#2e7d32" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-10 h-10">
    <path d="M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10z"/>
    <path d="M2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12"/>
  </svg>
);
const PeopleIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="#2e7d32" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-10 h-10">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
    <circle cx="9" cy="7" r="4"/>
    <path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>
  </svg>
);

export default function About() {
  return (
    <div className="min-h-screen bg-white">
      {/* Location bar */}
      <div className="bg-green-50 border-b border-green-100 text-center py-2 text-sm text-gray-600 mt-16">
        Serving <span className="font-semibold text-gray-800">Ulwe, Navi Mumbai - 410206</span>
      </div>

      <div className="max-w-3xl mx-auto px-4 py-12">
        {/* Title */}
        <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-8">About BalconyGreen</h1>

        {/* Our Story */}
        <section className="mb-10">
          <h2 className="text-xl font-bold text-gray-900 mb-4">Our Story</h2>
          <p className="text-gray-600 leading-relaxed mb-3">
            BalconyGreen started with a simple observation: many people in urban areas love plants but struggle to maintain them due to busy schedules and lack of expertise. We saw an opportunity to transform balconies across Navi Mumbai into thriving green spaces.
          </p>
          <p className="text-gray-600 leading-relaxed">
            Founded as a plant nursery with deep expertise in plant care, we recognized that selling plants was only half the solution. Plants need professional care to truly flourish. That's why we launched our maintenance service - to ensure every plant we deliver receives the best possible care.
          </p>
        </section>

        {/* Our Mission */}
        <section className="mb-10">
          <h2 className="text-xl font-bold text-gray-900 mb-4">Our Mission</h2>
          <p className="text-gray-600 leading-relaxed">
            To make professional plant care affordable and accessible to everyone in Navi Mumbai. We believe that every balcony deserves to be beautiful, and every plant deserves expert attention.
          </p>
        </section>

        {/* Why Choose Us */}
        <section className="mb-10">
          <h2 className="text-xl font-bold text-gray-900 mb-8">Why Choose Us?</h2>
          <div className="grid sm:grid-cols-3 gap-8 text-center">
            {[
              { Icon: AwardIcon,  title: 'Expert Knowledge', desc: 'Years of experience in plant care and gardening.' },
              { Icon: LeafIcon,   title: 'Quality Care',     desc: 'Professional attention to every plant in your collection.' },
              { Icon: PeopleIcon, title: 'Customer Focus',   desc: 'We prioritize your satisfaction and plant health.' },
            ].map(({ Icon, title, desc }) => (
              <div key={title} className="flex flex-col items-center">
                <div className="mb-3"><Icon /></div>
                <h3 className="font-bold text-gray-900 mb-2">{title}</h3>
                <p className="text-gray-500 text-sm leading-relaxed">{desc}</p>
              </div>
            ))}
          </div>
        </section>

        {/* Service Area */}
        <section className="mb-10">
          <h2 className="text-xl font-bold text-gray-900 mb-3">Service Area</h2>
          <p className="text-gray-600 leading-relaxed">
            Currently serving{' '}
            <span className="text-[#2e7d32] font-semibold">Ulwe, Navi Mumbai - 410206</span>.
            {" "}We're planning to expand to other areas soon!
          </p>
        </section>

        {/* Get In Touch box */}
        <section className="bg-green-50 border border-green-100 rounded-2xl p-6">
          <h2 className="text-xl font-bold text-gray-900 mb-2">Get In Touch</h2>
          <p className="text-gray-500 text-sm mb-4">Have questions about our service? Want to partner with us? Reach out!</p>
          <div className="space-y-2 text-sm">
            <p><span className="font-semibold text-gray-700">Phone:</span>{' '}<span className="text-[#2e7d32]">+91-7302472992</span></p>
            <p><span className="font-semibold text-gray-700">Email:</span>{' '}<span className="text-[#2e7d32]">support@balconygreen.in</span></p>
            <p><span className="font-semibold text-gray-700">Location:</span>{' '}Ulwe, Navi Mumbai - 410206</p>
          </div>
        </section>

        {/* CTA */}
        <div className="mt-10 flex flex-col sm:flex-row gap-3">
          <Link to="/book" className="px-6 py-3 bg-[#2e7d32] text-white font-semibold rounded-xl text-center hover:bg-[#1b5e20] transition-colors">
            Book a Service
          </Link>
          <Link to="/contact" className="px-6 py-3 border-2 border-[#2e7d32] text-[#2e7d32] font-semibold rounded-xl text-center hover:bg-green-50 transition-colors">
            Contact Us
          </Link>
        </div>
      </div>
    </div>
  );
}
